import { translate } from '../../../core';
import { Col, DatePicker, Flex, Form, Input, Row } from 'antd';
import { LabelFormItem } from '../../../core/component';
import { dateFormat } from '../../../core/until';
import { InputCard } from './InputCard';

type GiftwareTablewareType = 'tableware' | 'giftware'

export const ItemFromGiftwareTableware = ({type}: { type: GiftwareTablewareType }) => {
  return (
    <InputCard contained className='mt-4 bg-white'>
      <Form.Item noStyle name="type">
        <LabelFormItem/>
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Form.Item
            label={translate('discontinued', 'date')}
            name={[type, 'discontinuedDate']}
          >
            <DatePicker
              format={dateFormat}
              style={{width: '100%'}}
            />
          </Form.Item>
        </Col>
      </Row>
    </InputCard>
  )
}

export const ItemFormPatternNumber = ({type}: { type: GiftwareTablewareType }) => (
  <Form.Item>
    <Flex vertical>
      <label>{translate('pattern_number_abbr')}</label>
      <Form.Item noStyle name={[type, 'patternNumber']}>
        <Input style={{width: 200}}/>
      </Form.Item>
    </Flex>
  </Form.Item>
)
